"use client";

import React from 'react';
import {Button} from "@/components/ui/button";
import {cn} from "@/lib/utils";
import {useRouter} from "next/navigation";

const RemoveFilters = () => {
    const router = useRouter();
    return (
        <button
            className={cn("text-orange-primary shadow-none border-none text-sm")
            }
            onClick={() => router.push("?")}
        >
            حذف
            فیلترها
        </button>
    )

};

export default RemoveFilters;